import React from "react";
import { getNewsDetail } from "services";
import { BaseLayout, Loading } from "components";
import styles from "./styles.module.scss";
import { isNative } from 'utils';

class GuideDetail extends React.PureComponent {
  state = {
    loading: true,
  };
  componentDidMount() {
    const { history, match } = this.props;
    const { params } = match;
    if (!params.id || !Number.isInteger(parseInt(params.id))) {
      history.goBack();
    }
    this.getDetail();
  }
  getDetail = async () => {
    const { match } = this.props;
    const { params } = match;
    const res = await getNewsDetail(params.id);
    if (res.success) {
      this.setState({
        loading: false,
        ...res.ch_msg[0]
      });
    }
  };

  // 返回
  onBack = () => {
    window.history.back();
  }



  render() {
    const { loading, title, content, lctime } = this.state;
    return (
      <BaseLayout>
        {loading ? (
          <Loading />
        ) : (
            <section className={styles.detail_new}>

              {
                isNative ? null :
                  <header className={styles.header}>
                    <div className={styles.back} onClick={this.onBack} />
                    <div className={styles.title}>资讯详情</div>
                  </header>
              }
              <div className={styles.content} >
                <div className={styles.title}>{title}</div>
                <div className={styles.time}>{lctime && new Date(lctime).toLocaleString()}</div>

                <p className={styles.msg} dangerouslySetInnerHTML={{ __html: content }}></p>
              </div>
            </section>
          )}
      </BaseLayout>
    );
  }
}
export default GuideDetail;
